import { render, staticRenderFns } from "./DependenciesItemTask.vue?vue&type=template&id=5fc77563&scoped=true&"
import script from "./DependenciesItemTask.vue?vue&type=script&lang=js&"
export * from "./DependenciesItemTask.vue?vue&type=script&lang=js&"
import style0 from "./DependenciesItemTask.vue?vue&type=style&index=0&id=5fc77563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc77563",
  null
  
)

export default component.exports